import { CircleTickSolid } from '../../../assets/icons/Tickbox';

export const quoteModalContent = {
  title: 'Don’t miss out on our registration only offer!',
  description:
    'No extra cover could mean big repair bills if your appliance is accidentally damaged.',
  benefits: {
    heading: 'Get these exclusive benefits',
    benefitsList: [
      { icon: CircleTickSolid, text: 'Immediate coverage for accidental damage' },
      { icon: CircleTickSolid, text: 'Unlimited repairs with no surprise fees' },
      {
        icon: CircleTickSolid,
        text: 'If we can’t fix it, we’ll replace it with a like-for-like model',
      },
    ],
  },
};
